module.exports = __webpack_public_path__ + "static/img/spmp-1.42cc099.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spmp/spmp-1.png
// module id = LiqJ
// module chunks = 1